import axios from "@/axios";
import Util from "@/util/util";

export const namespaced = true;

export const state = {
  order: null,
  testOrdersFromServer: [],
  draftOrders: [],
  activeOrders: [],
  completedOrders: [],
  partnerNationOrders: [],
  orderCategories: [],
  ratificationJustifications: [],
  organizationOrders: [],
  partnerNationOrders:[],
  unsignedPNOrders: [],
  searchCriteria: [],
  searchResults: {},
  searchResultsReassignment: null,
  loadTestOrdersFromServer: false,
  searchValues: {},
};

export const getters = {
  order: (state) => {
    return state.order;
  },
   orderCategories: (state) => {return state.orderCategories},
   ratificationJustifications: (state) => {return state.ratificationJustifications},

  draftOrders: (state) => {
    return state.draftOrders;
  },
  activeOrders: (state) => {
    return state.activeOrders;
  },
  completedOrders: (state) => {
    return state.completedOrders;
  },
  partnerNationOrders: (state)=>{
    return state.partnerNationOrders
  },
  organizationOrders: (state) => {
    return state.organizationOrders;
  },
  partnerNationOrders:(state)=>{
    return state.partnerNationOrders
  },
  unsignedPNOrders: (state)=>{
    return state.unsignedPNOrders;
  },
  searchCriteria: (state) => {
    return state.searchCriteria;
  },
  searchResults: (state) => {
    return state.searchResults;
  },
  searchResultsReassignment:(state) =>{
    return state.searchResultsReassignment
  },
   searchValues: (state) => {
            return state.searchValues;
        }
};

export const mutations = {
  setTestOrdersFromServer: function (state, testOrdersFromServer) {
    state.testOrdersFromServer = testOrdersFromServer;
  },
  set_order: (state, response) => {
    state.order = response.data[0];
  },
  set_draft_orders: (state, response) => (state.draftOrders = response.data),
  set_submitted_orders: (state, response) =>
    (state.activeOrders = response.data),
  set_unsigned_orders: (state, response) =>
    (state.unsignedPNOrders = response.data),
  set_completed_orders: (state, response) =>
    (state.completedOrders = response.data),
    set_partnerNation_orders:(state,response)=>
    (state.partnerNationOrders = response.data),
  set_organization_orders: (state, response) =>
    (state.organizationOrders = response.data),
  set_search_criteria: (state, response) => (state.searchCriteria = response),
  set_search_results: (state, response) =>
    (state.searchResults = response.data),
  set_search_results_reassignement: (state, response) =>
    (state.searchResultsReassignment = response.data),
  
  set_order_categories: (state, response) => (state.orderCategories = response),
  set_ratification_justifications: (state,response)=> (state.ratificationJustifications = response),
  clear_search_results: (state) => (state.searchResults = []),
  clear_search_criteria: (state) => (state.searchCriteria = []),
  CLEAR_ORDER: (state) => (state.order = null),
   SET_SEARCH_VALUES: (state,  { key, value }) => (state.searchValues[key] = value),
   RESET_SEARCH_VALUES: (state) => {
  state.searchValues = {}
}
};

export const actions = {
  async getUserOrdersByStatus({ commit }, apiInfo) {
    commit(
      `set_${apiInfo.orderStatus}_orders`,
      await axios.get(`/api/orders/status/${apiInfo.orderStatus}/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/false/${apiInfo.searchText}`)
    );
  },
  async getOrderCategories({ commit }) {
    const response = await axios.get("/api/orders/ordercategory")
    const sortedResponse = response.data.sort((a, b) => {
      let fa = a.name.toLowerCase(),
        fb = b.name.toLowerCase();

    if (fa < fb) {
        return -1;
    }
    if (fa > fb) {
        return 1;
    }
    return 0;
    })
    commit('set_order_categories' , sortedResponse)
  },
  async getRatificationJustifications({ commit }) {
    const response = await axios.get("/api/ratifications")
    const sortedResponse = response.data.sort((a, b) => {
      let fa = a.name.toLowerCase(),
        fb = b.name.toLowerCase();
    if (fa < fb) {
        return -1;
    }
    if (fa > fb) {
        return 1;
    }
    return 0;
    })
    commit('set_ratification_justifications' , sortedResponse)
  },
  async deleteRatificationDocument({ commit }, { orderId, deleteReason }) {
    try {
      const response = await axios.delete(`/api/ratifications`, {
        data: {
          OrderId: orderId,
          DeletionReason: deleteReason
        }
      });
      return response;
    } catch (err) {
      throw err.response.data;
    }
  },

  async getAllOrdersByOrganization({ commit }, apiInfo) {
    commit(
      `set_${apiInfo.orderStatus}_orders`,
      await axios.get(`/api/orders/byuserorganization/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/false/${apiInfo.searchText}`)
    );
  },
  async getAllOrdersByParnationOrderUnsigned({ commit }, apiInfo) {
    commit(
      `set_${apiInfo.orderStatus}_orders`,
      await axios.get(`/api/orders/bycountry/unsigned/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/false/${apiInfo.searchText}`)
    );
  },
  async getAllOrdersByPartnerNation({ commit }, apiInfo) {
    //  false/${apiInfo.searchText}     - make it similar to line no 86
    commit(
      `set_partnerNation_orders`,
      await axios.get(`/api/orders/pn/manager/orders/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/false/${apiInfo.searchText}`)
    );
  },
  async getAllOrdersByCountry({ commit }, apiInfo) {
    commit(
      `set_${apiInfo.orderStatus}_orders`,
      await axios.get(`/api/orders/bycountry/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/false/${apiInfo.searchText}`)
    );
  },
  async getUserUnsignedOrdersExportToExcel({ commit }, apiInfo) {        
    try {
      let res = await axios({
        url: `/api/orders/bycountry/unsigned/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/true/${apiInfo.searchText}`,
        method: 'GET',
        responseType: "blob"
      });
      Util.fileDownload(res.data, 'Orders.xlsx');
      return true;
    } catch (err) {
      return false;
    }
  },
  async getUserOrdersByStatusForExportToExcel({ commit }, apiInfo) {        
    try {
      let res = await axios({
        url: `/api/orders/status/${apiInfo.orderStatus}/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/true/${apiInfo.searchText}`,
        method: 'GET',
        responseType: "blob"
      });
      Util.fileDownload(res.data, 'Orders.xlsx');
      return true;
    } catch (err) {
      return false;
    }
  },
  async getOrdersBySearchFieldsToExcel({commit}, apiInfo) {
    let res = await axios({
      url: "api/orders/search",
      method: "POST",
      data: apiInfo,
      responseType: "blob",
      config: { showToast: true, message: "File Successfully Exported" },
    });
    Util.fileDownload(res.data, "Orders.xlsx");    
  },

  async getUserOrdersByPnPartnerNationorExportToExcel({ commit }, apiInfo) {
    try {
      let res = await axios({
        url: `/api/orders/pn/manager/orders/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/true/${apiInfo.searchText}`,
        method: 'GET',
        responseType: "blob"
      });
      Util.fileDownload(res.data, 'Orders.xlsx');
      return true;
    } catch(error) {
      return false;
    }
    
  },

  async getUserOrdersByCountryForExportToExcel({ commit }, apiInfo) {
    try {
      let res = await axios({
        url: `/api/orders/bycountry/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/true/${apiInfo.searchText}`,
        method: 'GET',
        responseType: "blob"
      });
      Util.fileDownload(res.data, 'Orders.xlsx');
      return true;
    } catch(error) {
      return false;
    }
    
  },
  async getAllOrdersByOrganizationForExportToExcel({ commit }, apiInfo) {
    try {
      let res = await axios({
        url: `/api/orders/byuserorganization/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/true/${apiInfo.searchText}`,
        method: 'GET',
        responseType: "blob"
      });
      Util.fileDownload(res.data, "Orders.xlsx");
      return true;
    } catch(error) {
      return false;
    }
  },
  async getOrderByStatus({ commit }, { orderStatus, id }) {
    commit(
      "set_order",
      await axios.get(`/api/orders/bystatusname/${orderStatus}/${id}`)
    );
  },
  clearSearchResults({ commit }) {
    commit(`clear_search_results`);
  },
  clearSearchCriteria({ commit }) {
    commit(`clear_search_criteria`);
  },
  setSearchValues({ commit }, searchVal ) {
    commit('SET_SEARCH_VALUES',searchVal);

  },
  setSearchCriteria({ commit }, searchQuery) {
    this.searchCriteria = searchQuery;
    commit(`set_search_criteria`, searchQuery);
  },
  async getSearchResults({ commit }) {
    if (this.searchCriteria != undefined || this.searchCriteria != {}) {
      let ret = '';
      try {
        ret = await axios.post("api/orders/search", this.searchCriteria, {
          config: { showToast: false, message: "Search results loaded successfully" },
        });

        commit(`set_search_results`, ret);
      } catch (err) {
        console.log(err); // error Handeling
      }
  
    } else {
      commit(`set_search_results`, {});
    }
  },
  async getSearchResultsReassignment({commit}){
    if (this.searchCriteria != undefined || this.searchCriteria != {}) {
      let ret = '';
      try {
        ret =  await axios.post("api/orders/ids/orders", this.searchCriteria, {
          config: { showToast: true, message: "Search results loaded successfully" },
        });
        
        commit(
          `set_search_results_reassignement`,
          ret
        );
      } catch(err) {
        throw err.response.data;
      }
  
    } else {
      commit(`set_search_results_reassignement`, {});
    }
  },
  
  clearOrder({ commit }) {
    commit("CLEAR_ORDER");
  },
  clearAll: function (context) {
    context.commit("setTestOrdersFromServer", []);
    context.commit("set_draft_orders", []);
    context.commit("set_submitted_orders", []);
    context.commit("set_completed_orders", []);
    context.commit("set_organization_orders", []);
    context.commit("setLoadTestOrdersFromServer", false);
  },
};
